import React, { useCallback } from 'react';
import FlagIcon from '@mui/icons-material/Flag';
import { getPageSubtitle } from '../../constants/pageSubtitles';
import { superAdminAPI } from '../../services/api';
import { SuperAdminTogglePage } from './SuperAdminTogglePage';

const ITEMS = [
  { key: 'crmModules', label: 'CRM Modules', description: 'Allow tenants to create custom CRM modules' },
  { key: 'customFields', label: 'Custom Fields', description: 'Enable custom field builder' },
  { key: 'reports', label: 'Reports', description: 'Enable reporting engine' },
  { key: 'apiAccess', label: 'API Access', description: 'Allow REST API integrations' },
  { key: 'gpsTracking', label: 'GPS Tracking', description: 'Enable GPS device module' },
  { key: 'importExport', label: 'Import / Export', description: 'CSV import and export' },
];

export const FeatureFlagsPage: React.FC = () => {
  const load = useCallback(async () => (await superAdminAPI.getFeatureFlags()).data, []);
  const save = useCallback(async (data: Record<string, boolean>) => {
    await superAdminAPI.updateFeatureFlags(data);
  }, []);

  return (
    <SuperAdminTogglePage
      title="Feature Flags"
      icon={<FlagIcon />}
      subtitle={getPageSubtitle('feature_flags')}
      breadcrumb="Feature Flags"
      items={ITEMS}
      load={load}
      save={save}
    />
  );
};
